<template>
  <form @submit.prevent="confirm()">
    <div>
      <div>
        <div class="form-group">
          <label for="nom">Nom du cantonnier</label>
          <input type="text" class="form-control" id="nom" v-model="cantonnier.nom" maxlength="50" required>
        </div>

        <div class="form-group">
          <label for="prenom">Prénom du cantonnier</label>
          <input type="text" class="form-control" id="prenom" v-model="cantonnier.prenom" maxlength="50" required>
        </div>

        <label for="arrondissement">Arrondissement de rattachement</label>
        <div v-for="(arr, value) in currentVille.arrondissements" v-bind:key="value">
            <div class="radio">
            <label>
              <input type="radio" name="arrondissement" v-bind:value="arr.id" v-model="cantonnier.arrondissement_id" required>
              {{arr.nom}}
            </label>
          </div>
        </div>
      </div>

      <div class="buttons">
        <button class="btn btn-primary">Confirmer</button>
        <div class="btn btn-default" v-on:click="$emit('close')">
          Annuler
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import {mapGetters, mapState} from 'vuex'
import _ from 'lodash'

export default {
  computed: {
    ...mapState([
      'currentVille',
    ]),
  },
  props: [
    'updateCantonnier',
  ],
  data: function () {
    return {
      cantonnier: this.updateCantonnier ? _.cloneDeep(this.updateCantonnier) : {arrondissement_id: this.$store.state.currentVille.arrondissements[0].id,},
    }
  },
  mounted: function () {
  },
  methods: {
    confirm: function () {
      if (this.updateCantonnier) {
        this.$store.dispatch('updateCantonnier', this.cantonnier)
      } else {
        this.$store.dispatch('createCantonnier', this.cantonnier)
      }
      this.$emit('close')
    },
  },
}
</script>



// WEBPACK FOOTER //
// CantonniersForm.vue?3fb241c6